import "regenerator-runtime/runtime";

import * as cart from "@shopify/theme-cart";
import lazyload from "./lazyload";

import Currency from "./money-format";
import MediaGallery from "./pdp/master-gallery-slider";
import PDPListeners from "./pdp/pdp-listeners";
import HeaderListeners from "./listeners/header-listeners";
import RelatedProductSlider from "./pdp/related-product-slider";
import SparxScripts from "./sparx/sparx-scripts";
import HomeSliderSparx from "./sparx/homeSlider";
import HomepageHeroSliderView from "./views/HomepageHeroSliderView";
import HeaderCustomLanguageView from "./views/HeaderCustomLanguageView";
import PLPListener from "./plp/plp-listeners";

import { state, getAllProductsWithType } from "./model";

import RelatedProductsView from "./views/RelatedProductsView";
import customProductCard from "./components/custom-product-card";
import SRPListener from "./search/srp-listeners";

window.Cart = cart;

document.addEventListener("DOMContentLoaded", function () {
  const targets = [document.querySelector(".cart-body"), document.querySelector(".mini-cart-list")];

  // Function to modify the content of .gbbExtBundleContentsTextValue
  const updateContent = async () => {
    const elements = document.querySelectorAll(".gbbExtBundleContentsTextValue");

    let propertyKey = "Gift Wrapper";

    // Fetch the cart data
    const response = await fetch('/cart.js', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('Failed to fetch cart');
    }

    const cart = await response.json();

    // Find the item with the specific property key
    const item = cart.items.find(
      (item) => item.properties && Object.keys(item.properties).includes(propertyKey)
    );

    // Loop through each .gbbExtBundleContentsTextValue element
    elements.forEach((element) => {
      // Prevent double-wrapping: Check if a <ul> already exists
      if (element.querySelector("ul")) {
        console.log("Skipping update: <ul> already exists in", element);
        return; // Skip this element if it already contains a <ul>
      }

      const originalContent = element.innerHTML;
      const lines = originalContent.split("<br>").map(line => line.trim()).filter(line => line !== "");

      // Create a new <ul>
      const ul = document.createElement("ul");

      // Add each line as a <li> item
      lines.forEach((line) => {
        const li = document.createElement("li");
        li.textContent = line;
        ul.appendChild(li);
      });

      // If the item with the Gift Wrapper property exists, prepend it
      if (item) {
        const li = document.createElement("li");
        li.textContent = item.title;
        ul.prepend(li);
      }

      // Replace the original content with the new <ul>
      element.innerHTML = ""; // Clear the current content
      element.appendChild(ul); // Append the new <ul>
    });
  };

  // Observer configuration
  const observerConfig = { childList: true, subtree: true };

  // Create the MutationObserver
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.addedNodes.length > 0) {
        // Check for .gbbExtBundleContentsTextValue in added nodes
        mutation.addedNodes.forEach((node) => {
          if (
            node.nodeType === Node.ELEMENT_NODE &&
            node.querySelector(".gbbExtBundleContentsTextValue")
          ) {
            updateContent();
          }
        });
      }
    });
  });

  // Start observing the target elements
  targets.forEach((target) => {
    if (target) {
      observer.observe(target, observerConfig);
    }
  });

  // Initial update if the elements are already present
  updateContent();
});



document.addEventListener("DOMContentLoaded", function () {
  lazyload();
  SparxScripts.init();
  HeaderListeners.init();
  HomeSliderSparx.init();

  const productContainers = document.querySelectorAll('.collection-block.hm-product-slider');
  productContainers.forEach((container) => {
    customProductCard.init({
      containerSelector: `.${container.classList.value.split(' ').join('.')}`,
      notifyMeConfig: {
        enabled: true,
        triggerSelector: '.BIS_trigger.notify_me-btn',
      },
    });
  });
  

  if (
    window.objectData.template == "product" ||
    window.objectData.template == "product.th-bundle"
  ) {
    MediaGallery.init();
    RelatedProductSlider.init();
    PDPListeners.init();
  }

  if(window.objectData.template == "collection"){
    PLPListener.init();
  }

  if(window.objectData.template == "search"){
    SRPListener.init();
  }
  

});

const controlRelatedProducts = async () => {
  try {
    // 1. Get the Current product type
    const currentType = window.objectData.product?.type;
    if (langify) {
      if (langify.locale.iso_code === "ar") {
        await getAllProductsWithType("ar", currentType);
      } else {
        await getAllProductsWithType("en", currentType);
      }
    } else {
      await getAllProductsWithType("en", currentType);
    }
    RelatedProductsView.render(state.relatedProducts);
    RelatedProductsView.initSlider();
  } catch (err) {
    console.log(err.message);
  }
};

const controlHomepageHeroBannerVideos = (e) => {
  const parentEl = e.target.closest(".h__slide__inner > div");
  const allChildren = parentEl ? Array.from(parentEl.children) : null;
  if (!allChildren || allChildren.length < 1) return;
  const allVideoChildrens = allChildren.filter(
    (child) => child.localName == "video"
  );

  allVideoChildrens &&
    allVideoChildrens.forEach((v) => {
      if (v.paused) {
        v.play();
        v.closest(".h__slide__inner")
          .querySelector(".h__slide__play-icon")
          .classList.add("hide");
      } else {
        v.pause();
        v.closest(".h__slide__inner")
          .querySelector(".h__slide__play-icon")
          .classList.remove("hide");
      }
    });
};

function init() {
  HeaderCustomLanguageView.hanldeLanguageSwitcher();
  HomepageHeroSliderView.addHandlerClicks(controlHomepageHeroBannerVideos);
  HomepageHeroSliderView.initSlider();

  if (
    window.objectData.template == "product" ||
    window.objectData.template == "product.th-bundle"
  ) {
    RelatedProductsView.addHandlerLoad(controlRelatedProducts);
  }
}
window.$th_bundle_addtocart_callback = function () {
  $(".pdpmodal-addedtocart__modal").show();
  $(".pdpmodal-addedtocart__overlay").show();
  $("#shopify-section-header").load(location.href + " #shopify-section-header");
};
$(
  ".pdpmodal-addedtocart__modal__close-btn, .pdpmodal-addedtocart__modal__continue"
).click(function () {
  $(".pdpmodal-addedtocart__modal").hide();
  $(".pdpmodal-addedtocart__overlay").hide();
});
jQuery(document).on("click", ".mb-cart-flex", function () {
  $(".mini-cart-content").toggleClass("hide");
  $('body').toggleClass("cart_open");
});

init();
